<template>
  <div class="footerStyle">
    <div class="footerStyle_top"></div>
    <div class="footerStyle_bottom">
      <Row type="flex" justify="space-between" class="footerStyle_bottom_top">
        <i-col :xs="12" :sm="20" :md="20" :lg="20">
          <div class="footer_divider">
            <span class="footer_divider_font">商务合作</span>
            <Divider type="vertical" />
            <span class="footer_divider_font">意见反馈</span>
            <Divider type="vertical" />
            <span class="footer_divider_font">投诉</span>
          </div>
          <div class="footer_email">
            <!-- <div>
              联系电话:
              <span class="footer_email_item" id="telId">135-7074-5982</span>
            </div> -->
            <div>
              商务合作:
              <span class="footer_email_item" id="email001Id"
                >cooperation@willingdata.com</span
              >
            </div>
            <div>
              投诉建议:
              <span class="footer_email_item" id="email002Id"
                >mpai@willingdata.com</span
              >
            </div>
          </div>
        </i-col>
        <i-col :xs="12" :sm="4" :md="4" :lg="4">
          <img
            src="../../../public/static/image/img-code.jpg"
            class="imgStyle"
          />
        </i-col>
      </Row>
      <row class="footer_msg" align="bottom" type="flex" justify="center">
        <div>
          <div class="footer_url">
            <div style="width:100%">
              Copyright 2020 willingdata. All rights reserved.
            </div>
          </div>
          <div class="footer_url">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011202001229"
              ><img
                class="imgstyle"
                src="static/image/img-public-security.png"
              />
            </a>
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011202001229"
              >粤公网安备 44011202001229号 </a
            ><Divider type="vertical" />
            <a href="http://www.beian.miit.gov.cn/">粤ICP备20068983号</a>
          </div>
        </div>
      </row>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    copy(id) {
      var copycode = document.getElementById(id);
      copycode.select(); // 选择对象
      // 执行浏览器复制命令
      document.execCommand("Copy");
      this.$Message.success("复制成功");
    }
  }
};
</script>

<style lang="less" scoped>
@media screen and (min-width: 568px) {
  .footerStyle {
    position: relative;
    height: 380px;
    background: #313131;
    padding-left: 15vw;
    padding-right: 15vw;
    font-family: "微软雅黑" "宋体";
    bottom: 0;
    margin-bottom: 0px;
  }

  .footerStyle_top {
    height: 150px;
    border-bottom: 4px solid #7d7d7d;
  }
  .footer_email_item {
    cursor: text;
  }
  .footerStyle_bottom {
    height: 230px;
    padding-top: 10px;
    .footer_divider {
      font-size: 14px;
      color: #b9b9b9;
      .footer_divider_font {
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }
      .footer_divider_font:hover {
        color: #ffff;
      }
    }
    .footer_email {
      font-size: 14px;
      color: #b9b9b9;
      padding-top: 13px;
      cursor: default;
      a {
        color: #b9b9b9;
      }
      a:hover {
        color: #ffff;
      }
    }
    .imgStyle {
      width: 40%;
      float: right;
      padding-top: 5px;
    }
  }
  .footerStyle_bottom_top {
    height: 120px;
  }
  .footer_msg {
    width: 100%;
    height: 100px;
    text-align: center;
    .footer_url {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #b9b9b9;

      a {
        cursor: pointer;
        color: #b9b9b9;
        .imgstyle {
          cursor: pointer;
          height: 20px;
          padding-right: 2px;
        }
      }
      a:hover {
        color: #ffff;
      }
    }
  }
}
@media screen and (max-width: 568px) {
  .footerStyle {
    position: relative;
    height: 325px;
    background: #313131;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 25px;
    font-family: "微软雅黑" "宋体";
    bottom: 0;
    margin-bottom: 0px;
  }
  .footer_email_item {
    cursor: text;
  }
  .footerStyle_bottom {
    height: 300px;
    padding-top: 10px;
    .footer_divider {
      font-size: 20px;
      color: #b9b9b9;
      .footer_divider_font {
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
      }
      .footer_divider_font:hover {
        color: #ffff;
      }
    }
    .footer_email {
      font-size: 20px;
      color: #b9b9b9;
      padding-top: 13px;
      cursor: default;
      a {
        color: #b9b9b9;
      }
      a:hover {
        color: #ffff;
      }
    }
    .imgStyle {
      width: 40%;
      float: right;
      padding-top: 5px;
    }
  }
  .footerStyle_bottom_top {
    height: 200px;
  }
  .footer_msg {
    width: 100%;
    height: 90px;
    padding-bottom: 10px;
    text-align: center;
    margin-top: 3px;
    .footer_url {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #b9b9b9;
      a {
        cursor: pointer;
        color: #b9b9b9;
        .imgstyle {
          cursor: pointer;
          height: 20px;
          padding-right: 2px;
        }
      }
      a:hover {
        color: #ffff;
      }
    }
  }
}
</style>
